export default __webpack_public_path__ + "static/media/pulse.252f036f.svg";